import { render } from "./uploadFileView.vue?vue&type=template&id=19f95a88&scoped=true"
import script from "./uploadFileView.vue?vue&type=script&lang=js"
export * from "./uploadFileView.vue?vue&type=script&lang=js"

import "./uploadFileView.vue?vue&type=style&index=0&id=19f95a88&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f95a88"]])

export default __exports__